import React, { useCallback } from 'react'
import ReactMarkdown from 'react-markdown'

type THighlightProps = {
  type?: 'whole' | 'partial'
  keywords: string
  htmlFragment: string
}

const stopWordsReg = /[\s,.?!\-_()[\]~`;:"'|^&<>/*\\]/
const filterReg = /[^:,.!?;]*\*\*[\w\s]+\*\*[^:,.!?;]*/g

const Highlight = ({ type = 'whole', keywords, htmlFragment }: THighlightProps) => {
  const addHightlightTag = useCallback(() => {
    let newHtmlFragment = htmlFragment
    if (keywords && newHtmlFragment) {
      const keys = keywords.split(stopWordsReg).filter((key) => key !== '')
      keys.forEach((key) => {
        const reg = new RegExp(`(${key})`, 'gi')
        const keyIndex = newHtmlFragment.search(reg)
        if (keyIndex > 2 && newHtmlFragment.slice(keyIndex - 2, keyIndex) === '**') {
          const formatHtmlFragment = `${newHtmlFragment.substring(
            0,
            keyIndex - 2,
          )}${newHtmlFragment.substring(keyIndex)}`
          newHtmlFragment = formatHtmlFragment.replace(reg, `$1**`)
        } else {
          newHtmlFragment = newHtmlFragment.replace(reg, `**$1**`)
        }
      })
    }
    if (newHtmlFragment && newHtmlFragment.length > 100 && type === 'partial') {
      const matchFragment = newHtmlFragment.match(filterReg)
      if (matchFragment && matchFragment.length > 1) {
        let partialFragment = ''
        matchFragment.forEach((item) => {
          partialFragment += item + '...'
        })
        newHtmlFragment = partialFragment
      }
    }
    return newHtmlFragment
  }, [type, keywords, htmlFragment])

  const source = addHightlightTag()

  return <ReactMarkdown>{source}</ReactMarkdown>
}

export default Highlight
